var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-skeleton",style:({ height: _vm.height + 'px' })},[_c('div',{staticClass:"chart-skeleton__plot"},_vm._l((_vm.bars),function(bar,index){return _c('div',{key:index,staticClass:"chart-skeleton__bar",style:({ height: bar + '%' })})}),0),_vm._v(" "),_c('div',{staticClass:"chart-skeleton__axis"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b61a0558","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charts/ChartSkeleton.vue
// module id = 2130
// module chunks = 27